import baseAPI from "@/api/base";
import {
  EditParentTemplateFolder,
  GetParentTemplateFolder,
  RegisterParentTemplateFolder,
} from "@/dtos/ParentTemplateFolder.dto";
import {
  DELETE_PARENT_TEMPLATE_FOLDER_URL,
  EDIT_PARENT_TEMPLATE_FOLDER_URL,
  GET_PARENT_TEMPLATE_FOLDER_URL,
  REGISTER_PARENT_TEMPLATE_FOLDER_URL,
  TOGGLE_PARENT_TEMPLATE_FOLDER_IS_ACTIVE_URL,
} from "@/utils/urls";
import { AxiosResponse } from "axios";

class ParentTemplateFolder {
  static getParentTemplateFolders = async (
    getParentTemplateFolder: GetParentTemplateFolder
  ): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.get(GET_PARENT_TEMPLATE_FOLDER_URL, {
      params: getParentTemplateFolder,
    });
    return response;
  };

  static registerParentTemplateFolder = async (
    registerParentTemplateFolder: RegisterParentTemplateFolder
  ): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.post(REGISTER_PARENT_TEMPLATE_FOLDER_URL, {
      ...registerParentTemplateFolder,
    });
    return response;
  };

  static editParentTemplateFolder = async (
    editParentTemplateFolder: EditParentTemplateFolder
  ): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.put(EDIT_PARENT_TEMPLATE_FOLDER_URL, {
      ...editParentTemplateFolder,
    });
    return response;
  };

  static toggleParentTemplateFolderIsActive = async (
    editParentTemplateFolder: EditParentTemplateFolder
  ): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.patch(
      TOGGLE_PARENT_TEMPLATE_FOLDER_IS_ACTIVE_URL,
      {
        ...editParentTemplateFolder,
      }
    );
    return response;
  };

  static deleteParentTemplateFolder = async (id: string): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.delete(
      `${DELETE_PARENT_TEMPLATE_FOLDER_URL}/${id}`
    );
    return response;
  };
}

export default ParentTemplateFolder;
